import { Segment, SegmentOption } from './Segment';
import { SegmentedControlType } from './SegmentedControl.consts';
import { segmentedControlStyles } from './SegmentedControl.styles';

interface SegmentedControlProps<SegmentValue extends string> {
  segmentOptions: SegmentOption<SegmentValue>[];
  type: SegmentedControlType;
  value: SegmentValue;
  onClick?: (value: SegmentValue) => void;
}

const SegmentedControl = <SegmentValue extends string>({
  segmentOptions,
  type,
  value,
  onClick
}: SegmentedControlProps<SegmentValue>) => {
  const controlClasses = segmentedControlStyles({ controlType: type });

  return (
    <div className={controlClasses} data-testid="segmented-control">
      {segmentOptions.map((segmentOption, index) => (
        <div
          className="flex flex-1"
          data-testid={`segment-container-${segmentOption.value}`}
          key={segmentOption.value}
        >
          <Segment<SegmentValue>
            isSelected={value === segmentOption.value}
            numSegments={segmentOptions.length}
            onClick={onClick}
            segment={segmentOption}
            segmentIndex={index}
            type={type}
          />
        </div>
      ))}
    </div>
  );
};

export default SegmentedControl;
